/**
 * © 2026 Grupo Salamander SAPI de CV
 *
 * MuiAvatar component overrides for the Renaissance design system.
 * The initials/icon/fallback state (`colorDefault`, i.e. no loaded image)
 * paints the instance accent gradient, the same as `UIRowAvatar`.
 */

import type { Theme } from '@mui/material'

import { primaryAvatarPaint } from '../hyper'

export function avatarOverrides() {
  return {
    MuiAvatar: {
      styleOverrides: {
        // `colorDefault` is a modifier class (`avatarClasses.colorDefault`),
        // not a public `AvatarProps` field — targeted via its generated
        // class name rather than the theme `variants` array, which only
        // type-checks against public props.
        root: ({ theme }: { theme: Theme }) => ({
          '&.MuiAvatar-colorDefault': {
            ...primaryAvatarPaint(theme.palette.primary),
          },
        }),
      },
    },
  }
}
